import * as profiles from '../shared/constants/profile.constants';

const Home = {
  text: 'Home',
  link: '/home',
  icon: 'bi bi-house',
  translate: 'sidebar.menu.HOME',
  allow: [profiles.PROFILE_HOME]
};

const headingMain = {
  text: 'Main Menu',
  heading: true,
  translate: 'sidebar.heading.MAINMENU'
};

const Administration = {
  text: 'Administration',
  icon: 'bi bi-gear',
  link: 'administration',
  translate: 'sidebar.menu.ADMINISTRATION',
  allow: profiles.PROFILE_VIEW_ADMINISTRATION,
  submenu: [
    {
      text: 'User',
      link: '/administration/user',
      translate: 'sidebar.menu.submenu.administration.USER',
      allow: [profiles.PROFILE_READ_USER]
    },
    {
      text: 'Profile',
      link: '/administration/profile',
      translate: 'sidebar.menu.submenu.administration.PROFILE',
      allow: [profiles.PROFILE_READ_PROFILE]
    },
    {
      text: 'Feature Flags',
      link: '/administration/feature-flags',
      translate: 'sidebar.menu.submenu.administration.FEATURE_FLAGS',
      allow: [profiles.PROFILE_WRITE_FEATURE_FLAGS]
    }
  ]
};

const Report = {
  text: 'Report',
  icon: 'bi bi-pencil-square',
  link: 'report',
  translate: 'sidebar.menu.REPORT',
  allow: profiles.PROFILE_VIEW_REPORT,
  submenu: [
    {
      text: 'Report',
      link: '/report/report',
      translate: 'sidebar.menu.submenu.report.REPORT',
      allow: [profiles.PROFILE_READ_REPORT]
    }
  ]
};

const Drug = {
  text: 'Drug',
  icon: 'bi bi-droplet',
  link: 'drug',
  translate: 'sidebar.menu.DRUG',
  allow: profiles.PROFILE_VIEW_DRUG,
  submenu: [
    {
      text: 'Drug',
      link: '/drug/drug',
      translate: 'sidebar.menu.submenu.drug.DRUG',
      allow: [profiles.PROFILE_READ_DRUG]
    },
    {
      text: 'Generic',
      link: '/drug/generic',
      translate: 'sidebar.menu.submenu.drug.GENERIC',
      allow: [profiles.PROFILE_READ_DRUG_GENERIC]
    },
    {
      text: 'Calculator',
      link: '/drug/calculator',
      translate: 'sidebar.menu.submenu.drug.CALCULATOR',
      allow: [profiles.PROFILE_READ_DRUG_CALCULATOR]
    },
    {
      text: 'Treatment',
      link: '/drug/treatment',
      translate: 'sidebar.menu.submenu.drug.TREATMENT',
      allow: [profiles.PROFILE_READ_DRUG_TREATMENT]
    }
  ]
};

const DrugComponent = {
  text: 'Drug Components',
  icon: 'bi bi-collection',
  translate: 'sidebar.menu.DRUGCOMPONENT',
  allow: profiles.PROFILE_VIEW_DRUG_COMPONENT,
  submenu: [
    {
      text: 'Administration',
      link: '/drug/administration',
      translate: 'sidebar.menu.submenu.component.drug.ADMINISTRATION',
      allow: [profiles.PROFILE_READ_ADMINISTRATION]
    },
    {
      text: 'Adverse Effect',
      link: '/drug/adverse-effect',
      translate: 'sidebar.menu.submenu.component.drug.ADVERSEEFFECT',
      allow: [profiles.PROFILE_READ_ADVERSE_EFFECT]
    },
    {
      text: 'Commercial',
      link: '/drug/commercial',
      translate: 'sidebar.menu.submenu.component.drug.COMMERCIAL',
      allow: [profiles.PROFILE_READ_COMMERCIAL]
    },
    {
      text: 'Commercial Form',
      link: '/drug/commercial-form',
      translate: 'sidebar.menu.submenu.component.drug.COMMERCIALFORM',
      allow: [profiles.PROFILE_READ_COMMERCIAL_FORM]
    },
    {
      text: 'Contraindication',
      link: '/drug/contraindication',
      translate: 'sidebar.menu.submenu.component.drug.CONTRAINDICATION',
      allow: [profiles.PROFILE_READ_CONTRAINDICATION]
    },
    {
      text: 'Drug Subtype',
      link: '/drug/drug-subtype',
      translate: 'sidebar.menu.submenu.component.drug.DRUGSUBTYPE',
      allow: [profiles.PROFILE_READ_DRUG_SUBTYPE]
    },
    {
      text: 'Drug Type',
      link: '/drug/drug-type',
      translate: 'sidebar.menu.submenu.component.drug.DRUGTYPE',
      allow: [profiles.PROFILE_READ_DRUG_TYPE]
    },
    {
      text: 'Formula',
      link: '/drug/formula',
      translate: 'sidebar.menu.submenu.component.drug.FORMULA',
      allow: [profiles.PROFILE_READ_FORMULA]
    },
    {
      text: 'Frequency Quantity',
      link: '/drug/frequency-quantity',
      translate: 'sidebar.menu.submenu.component.drug.FREQUENCYQUANTITY',
      allow: [profiles.PROFILE_READ_FREQUENCY_QUANTITY]
    },
    {
      text: 'Frequency Time',
      link: '/drug/frequency-time',
      translate: 'sidebar.menu.submenu.component.drug.FREQUENCYTIME',
      allow: [profiles.PROFILE_READ_FREQUENCY_TIME]
    },
    {
      text: 'Modifier',
      link: '/drug/modifier',
      translate: 'sidebar.menu.submenu.component.drug.MODIFIER',
      allow: [profiles.PROFILE_READ_MODIFIER]
    },
    {
      text: 'Laboratory',
      link: '/drug/laboratory',
      translate: 'sidebar.menu.submenu.component.drug.LABORATORY',
      allow: [profiles.PROFILE_READ_LABORATORY]
    },
    {
      text: 'Pathology',
      link: '/drug/pathology',
      translate: 'sidebar.menu.submenu.component.drug.PATHOLOGY',
      allow: [profiles.PROFILE_READ_PATHOLOGY]
    },
    {
      text: 'Pharmaceutical Form',
      link: '/drug/pharmaceutical-form',
      translate: 'sidebar.menu.submenu.component.drug.PHARMACEUTICALFORM',
      allow: [profiles.PROFILE_READ_PHARMACEUTICAL_FORM]
    },
    {
      text: 'Situation',
      link: '/drug/situation',
      translate: 'sidebar.menu.submenu.component.drug.SITUATION',
      allow: [profiles.PROFILE_READ_SITUATION]
    },
    {
      text: 'Severity',
      link: '/drug/severity',
      translate: 'sidebar.menu.submenu.component.drug.SEVERITY',
      allow: [profiles.PROFILE_READ_SEVERITY]
    },
    {
      text: 'Unit Measure',
      link: '/drug/unit-measure',
      translate: 'sidebar.menu.submenu.component.drug.UNITMEASURE',
      allow: [profiles.PROFILE_READ_UNIT_MEASURE]
    }
  ]
};

const ReportComponent = {
  text: 'Report Component',
  icon: 'bi bi-collection',
  link: 'report',
  translate: 'sidebar.menu.REPORTCOMPONENT',
  allow: profiles.PROFILE_VIEW_REPORT_COMPONENT,
  submenu: [
    {
      text: 'Author',
      link: '/report/author',
      translate: 'sidebar.menu.submenu.component.report.AUTHOR',
      allow: [profiles.PROFILE_READ_AUTHOR]
    },
    {
      text: 'Report Type',
      link: '/report/report-type',
      translate: 'sidebar.menu.submenu.component.report.REPORTTYPE',
      allow: [profiles.PROFILE_READ_REPORT_TYPE]
    },
    {
      text: 'Specialty',
      link: '/report/specialty',
      translate: 'sidebar.menu.submenu.component.report.SPECIALTY',
      allow: [profiles.PROFILE_READ_SPECIALTY]
    }
  ]
};

const CongressComponent = {
  text: 'Congress Component',
  icon: 'bi bi-collection',
  link: 'congress',
  translate: 'sidebar.menu.CONGRESSCOMPONENT',
  allow: profiles.PROFILE_VIEW_CONGRESS_COMPONENT,
  submenu: [
    {
      text: 'Sponsor',
      link: '/congress/sponsor',
      translate: 'sidebar.menu.submenu.component.congress.SPONSOR',
      allow: [profiles.PROFILE_READ_SPONSOR],
    },
    {
      text: 'Sponsor Type',
      link: '/congress/sponsor-type',
      translate: 'sidebar.menu.submenu.component.congress.SPONSORTYPE',
      allow: [profiles.PROFILE_READ_SPONSOR_TYPE],
    }
  ]
};

const Congress = {
  text: 'Congress',
  icon: 'bi bi-chat-square-text',
  link: 'congress',
  translate: 'sidebar.menu.CONGRESS',
  allow: profiles.PROFILE_VIEW_CONGRESS,
  submenu: [
    {
      text: 'Migrate',
      link: '/congress/migrate',
      translate: 'sidebar.menu.submenu.congress.MIGRATE',
      allow: [profiles.PROFILE_READ_MIGRATE],
    },
    {
      text: 'Sponsor',
      link: '/congress/congress-sponsor',
      translate: 'sidebar.menu.submenu.congress.SPONSOR',
      allow: [profiles.PROFILE_READ_CONGRESS_SPONSOR],
    },
  ],
};

const Vaccine = {
  text: 'Vaccine',
  icon: 'bi bi-shield-plus',
  link: 'vaccine',
  translate: 'sidebar.menu.VACCINE',
  allow: profiles.PROFILE_VIEW_VACCINE,
  submenu: [
    {
      text: 'Vaccines',
      link: '/vaccine/manager/vaccines',
      translate: 'sidebar.menu.submenu.vaccine.VACCINES',
      allow: [profiles.PROFILE_READ_VACCINE_CORE]
    }
  ]
};

const VaccineComponent = {
  text: 'Vaccine Components',
  icon: 'bi bi-collection',
  translate: 'sidebar.menu.VACCINECOMPONENT',
  allow: profiles.PROFILE_VIEW_VACCINE_COMPONENT,
  submenu: [
    // Core
    {
      text: 'Vaccines',
      link: '/vaccine/core/vaccines',
      translate: 'sidebar.menu.submenu.component.vaccine.VACCINES',
      allow: [profiles.PROFILE_READ_VACCINE_CORE]
    },
    {
      text: 'Vaccine Groups',
      link: '/vaccine/core/vaccine-groups',
      translate: 'sidebar.menu.submenu.component.vaccine.VACCINE_GROUPS',
      allow: [profiles.PROFILE_READ_VACCINE_CORE]
    },
    {
      text: 'Vaccine Statuses',
      link: '/vaccine/core/vaccine-statuses',
      translate: 'sidebar.menu.submenu.component.vaccine.VACCINE_STATUSES',
      allow: [profiles.PROFILE_READ_VACCINE_CORE]
    },
    // Doses
    {
      text: 'Dose Statuses',
      link: '/vaccine/doses/dose-statuses',
      translate: 'sidebar.menu.submenu.component.vaccine.DOSE_STATUSES',
      allow: [profiles.PROFILE_READ_VACCINE_DOSES]
    },
    {
      text: 'Dose Schedules',
      link: '/vaccine/doses/dose-schedules',
      translate: 'sidebar.menu.submenu.component.vaccine.DOSE_SCHEDULES',
      allow: [profiles.PROFILE_READ_VACCINE_DOSES]
    },
    {
      text: 'Dose Status Conditions',
      link: '/vaccine/doses/dose-status-conditions',
      translate: 'sidebar.menu.submenu.component.vaccine.DOSE_STATUS_CONDITIONS',
      allow: [profiles.PROFILE_READ_VACCINE_DOSES]
    },
    // Alerts
    {
      text: 'Alerts',
      link: '/vaccine/alerts/alerts',
      translate: 'sidebar.menu.submenu.component.vaccine.ALERTS',
      allow: [profiles.PROFILE_READ_VACCINE_ALERTS]
    },
    {
      text: 'Alert Variables',
      link: '/vaccine/alerts/alert-variables',
      translate: 'sidebar.menu.submenu.component.vaccine.ALERT_VARIABLES',
      allow: [profiles.PROFILE_READ_VACCINE_ALERTS]
    },
    // Rules
    {
      text: 'Conditions',
      link: '/vaccine/rules/conditions',
      translate: 'sidebar.menu.submenu.component.vaccine.CONDITIONS',
      allow: [profiles.PROFILE_READ_VACCINE_RULES]
    },
    {
      text: 'Condition Operators',
      link: '/vaccine/rules/condition-operators',
      translate: 'sidebar.menu.submenu.component.vaccine.CONDITION_OPERATORS',
      allow: [profiles.PROFILE_READ_VACCINE_RULES]
    },
    {
      text: 'Recommendations',
      link: '/vaccine/rules/recommendations',
      translate: 'sidebar.menu.submenu.component.vaccine.RECOMMENDATIONS',
      allow: [profiles.PROFILE_READ_VACCINE_RULES]
    },
    {
      text: 'Recommendation Types',
      link: '/vaccine/rules/recommendation-types',
      translate: 'sidebar.menu.submenu.component.vaccine.RECOMMENDATION_TYPES',
      allow: [profiles.PROFILE_READ_VACCINE_RULES]
    },
    // Questions
    {
      text: 'Evaluation Questions',
      link: '/vaccine/questions/evaluation-questions',
      translate: 'sidebar.menu.submenu.component.vaccine.EVALUATION_QUESTIONS',
      allow: [profiles.PROFILE_READ_VACCINE_QUESTIONS]
    },
    {
      text: 'Question Types',
      link: '/vaccine/questions/question-types',
      translate: 'sidebar.menu.submenu.component.vaccine.QUESTION_TYPES',
      allow: [profiles.PROFILE_READ_VACCINE_QUESTIONS]
    },
    {
      text: 'Question Groups',
      link: '/vaccine/questions/question-groups',
      translate: 'sidebar.menu.submenu.component.vaccine.QUESTION_GROUPS',
      allow: [profiles.PROFILE_READ_VACCINE_QUESTIONS]
    },
    {
      text: 'Question Options',
      link: '/vaccine/questions/question-options',
      translate: 'sidebar.menu.submenu.component.vaccine.QUESTION_OPTIONS',
      allow: [profiles.PROFILE_READ_VACCINE_QUESTIONS]
    },
    {
      text: 'Question Dependencies',
      link: '/vaccine/questions/question-dependencies',
      translate: 'sidebar.menu.submenu.component.vaccine.QUESTION_DEPENDENCIES',
      allow: [profiles.PROFILE_READ_VACCINE_QUESTIONS]
    },
    {
      text: 'Question Actions',
      link: '/vaccine/questions/question-actions',
      translate: 'sidebar.menu.submenu.component.vaccine.QUESTION_ACTIONS',
      allow: [profiles.PROFILE_READ_VACCINE_QUESTIONS]
    },
    {
      text: 'Question Alerts',
      link: '/vaccine/questions/question-alerts',
      translate: 'sidebar.menu.submenu.component.vaccine.QUESTION_ALERTS',
      allow: [profiles.PROFILE_READ_VACCINE_QUESTIONS]
    }
  ]
};

const headingComponent = {
  text: 'Components',
  heading: true,
  translate: 'sidebar.heading.COMPONENT'
};

export const menu = [
  headingMain,
  Home,
  Administration,
  Drug,
  Report,
  Congress,
  Vaccine,
  headingComponent,
  DrugComponent,
  ReportComponent,
  CongressComponent,
  VaccineComponent
];
